// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"b220e0e8","453":"2e2a32ec"}[chunkId] + ".chunk.js";
};